<template>
  <div class="serve_introduce">
    <template v-if="!isChildBirthSpuId">
      <div class="bright-content" v-if="serverIntroduce">
        <div class="bright" v-if="serverIntroduce.pointDesc">
          <div class="serve_introduce_title pf-medium">套餐亮点</div>
          <div class="content_detail">{{ serverIntroduce.pointDesc }}</div>
        </div>
        <div
          class="content"
          :style="{ 'margin-top': serverIntroduce.pointDesc ? '0.32rem' : 0 }"
          v-if="packageContent"
        >
          <div class="serve_introduce_title pf-medium">套餐内容</div>

          <div class="content_detail" style="padding-bottom: 0.26rem">
            <ul v-if="packageContent.list && packageContent.list.length > 0">
              <li v-for="(item, index) in packageContent.list" :key="index">
                <label>{{ item.itemName }}</label
                ><span>{{ item.itemNum }}次</span>
              </li>
            </ul>

            <div
              v-for="(item, index) in packageContent.selectGroupList"
              :key="index"
            >
              <h3 v-if="item.contentList && item.contentList.length > 0">
                选做项目<span v-if="item.itemChooseNum"
                  >（以下项目{{ item.contentList.length }}选{{
                    item.itemChooseNum
                  }}）</span
                >
              </h3>
              <ul>
                <li v-for="(subItem, index) in item.contentList" :key="index">
                  <label>{{ subItem.itemName }}</label
                  ><span>{{ subItem.itemNum }}次</span>
                </li>
              </ul>
            </div>

            <p v-if="packageContent.otherDesc">
              其他说明：{{ packageContent.otherDesc }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="combo-detail"
        v-if="packageDetail.length > 0"
        :class="{
          isAll: showPdIndex >= packageDetail.length,
          noMore: packageDetail.length <= 2
        }"
      >
        <div class="serve_introduce_title pf-medium">项目详情</div>
        <ul>
          <li
            v-for="(item, index) in packageDetail"
            :key="index"
            v-show="showPdIndex >= index"
          >
            <h4>{{ item.title }}</h4>
            <div class="block-ui">
              <div class="one-line" v-for="(obj, i) in item.list" :key="i">
                <template v-if="isShowPackageDetailItem(obj)">
                  <label>{{ obj.lable }}</label>
                  <div v-if="isString(obj.value)">{{ obj.value }}</div>
                  <div
                    v-else-if="obj.value && obj.value.length > 0"
                    class="one-line-ul"
                    :class="{ 'position-ui': obj.name == 'position' }"
                  >
                    <p v-for="(po, s) in obj.value" :key="s">
                      <span v-if="obj.value.length > 1">{{ s + 1 }}.</span
                      >{{ obj.name == 'flow' ? po.value : po.text
                      }}<i v-if="obj.name == 'position'">，</i>
                    </p>
                  </div>
                  <div
                    v-else-if="obj.text || (obj.value && obj.value.length != 0)"
                  >
                    {{ obj.text || obj.value }}
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
        <button class="more-look" @click="openPackageDetail"></button>
      </div>
    </template>
    <div
      class="image_text"
      v-if="(cmmdtyPicDetail && cmmdtyPicDetail.length > 0) || product.content"
      :class="{ isAll: !!isAllImgText, noMore: noImgText, isChildBirthSpuId }"
    >
      <div
        class="serve_introduce_title margin_img_text pf-medium"
        :style="{
          'padding-top':
            packageDetail.length === 0 &&
            packageContent.list.length === 0 &&
            packageContent.selectGroupList.length === 0
              ? '0.24rem'
              : '0px'
        }"
      >
        图文详情
      </div>
      <div class="pDetail" v-if="cmmdtyPicDetail && cmmdtyPicDetail.length > 0">
        <div
          class="img-detail"
          v-for="(item, index) in cmmdtyPicDetail"
          :key="index"
        >
          <img v-lazy="item" alt="" />
        </div>
      </div>
      <div class="pDetail" v-else v-xhtml="product.content"></div>
      <button
        class="more-look"
        v-if="!isChildBirthSpuId"
        @click="openImgTextDetail"
      ></button>
    </div>
  </div>
</template>

<script>
import utils from '@/plugins/utils'
import { mapState } from 'vuex'
import {
  isEmptyObject,
  isNonEmptyArray,
  isNullOrEmpty,
  isString
} from '@/utils'
import { checkIfChildBirthSpuId } from '@/business/childbirth-service-package'

export default {
  props: {
    product: {
      type: Object
    }
  },
  computed: {
    ...mapState(['selectedSku']),
    serverIntroduce() {
      //接口设计结构很有问题
      return this.product && this.product.itemFrontVo
    },
    cmmdtyPicDetail() {
      // 图文详情
      const list =
        this.product && this.product.cmmdtyPicDetail
          ? this.product.cmmdtyPicDetail.split(',')
          : []
      return list
    },
    packageContent() {
      // 套餐内容
      let requireItems =
        this.serverIntroduce && this.serverIntroduce.requireItems
          ? this.serverIntroduce.requireItems
          : []

      let optionItemGroupList =
        this.serverIntroduce && this.serverIntroduce.optionItemList
          ? this.serverIntroduce.optionItemList
          : []

      const otherDesc = this.serverIntroduce && this.serverIntroduce.otherDesc

      function getList(items) {
        const list = []
        items.forEach((item, index) => {
          if (item && item.list) {
            const one = {}
            item.list.forEach((obj, i) => {
              if (obj.name == 'itemName' || obj.name == 'itemNum') {
                one[obj.name] = obj.value
              }
            })

            if (one && one.itemName && one.itemNum) {
              list.push(one)
            }
          }
        })
        return list
      }

      const content = {
        list: [],
        selectGroupList: [],
        otherDesc
      }

      const requireItemsList = this.serialization(requireItems)
      content.list = getList(requireItemsList)

      // optionItemGroupList不可map直接处理破坏原结构，否则导致packageDetail()错误
      optionItemGroupList.forEach(item => {
        const selectList = this.serialization(item.contentList)
        let list = getList(selectList)
        content.selectGroupList.push({
          contentList: list,
          itemChooseNum: item.itemChooseNum
        })
      })

      return content
    },
    packageDetail() {
      // 套餐详情
      let requireItems =
        this.serverIntroduce && this.serverIntroduce.requireItems
          ? this.serverIntroduce.requireItems
          : []

      let optionItemGroupList =
        this.serverIntroduce && this.serverIntroduce.optionItemList
          ? this.serverIntroduce.optionItemList
          : []

      let optionItems = []
      optionItemGroupList.forEach(item => {
        optionItems.push(...item.contentList)
      })

      let reqList = this.serialization(requireItems)
      let optionList = this.serialization(optionItems)

      function filterList(list = []) {
        return list.map(obj => {
          const itemType1 =
            obj.list.find(item => item.name == 'itemType1') || {}
          obj.list = obj.list.filter(
            item =>
              item.name !== 'itemName' &&
              item.name !== 'itemNum' &&
              item.name !== 'itemType1'
          )
          obj.list = obj.list.map(item => {
            if (item.name == 'itemTimes') item.value = `${item.value}分钟`
            // 可解决 378行所指问题，但本期不改，保持原样。20210430
            // if (item.name == "itemType2") item.value = `${item.text}`;

            // 露出itemType1的值，和itemType2一起显示
            if (item.name == 'itemType2' && itemType1.text)
              item.text = `${itemType1.text}-${item.text}`
            return item
          })
          return obj
        })
      }

      reqList = filterList(reqList)
      optionList = filterList(optionList)
      return [...reqList, ...optionList]
    }
  },
  async created() {
    this.isChildBirthSpuId = await checkIfChildBirthSpuId(this)
  },
  data() {
    return {
      isAllImgText: false,
      showPdIndex: 1,
      noImgText: false,
      isChildBirthSpuId: true
    }
  },
  mounted() {
    console.log(this.cmmdtyPicDetail)
    if (this.cmmdtyPicDetail && this.cmmdtyPicDetail.length == 1) {
      const img = new Image()
      img.src = this.cmmdtyPicDetail[0]
      img.onload = () => {
        const w = img.width
        const h = img.height

        const h1 = (414 * w) / 690
        if (h <= h1) {
          this.noImgText = true
        }
      }
    }
  },
  methods: {
    isShowPackageDetailItem(obj) {
      let bool = false
      let { value, text } = obj
      if (isString(value) && value.length > 0) {
        bool = true
      } else if (isNonEmptyArray(value)) {
        let tmp = value[0]
        if (!isEmptyObject(tmp) && !isNullOrEmpty(tmp.value)) {
          bool = true
        }
      } else if (isString(text) && text.length > 0) {
        bool = true
      }
      return bool
    },
    isString(str) {
      return typeof str === 'string'
    },
    openPackageDetail() {
      const skuid = this.selectedSku && this.selectedSku.skuId
      const popid = this.product && this.product.businessId
      this.newTrackClick(
        200005,
        undefined,
        `skuid: ${skuid || ''}, popid: ${popid || ''}`,
        121012367
      )
      this.showPdIndex = this.showPdIndex > 1 ? 1 : Infinity
    },
    serialization(requireItems = []) {
      const newRequireItems = requireItems.map(item => {
        const newItem = {}
        newItem.list = JSON.parse(item).map(obj => {
          if (obj.name == 'itemName') {
            newItem.title = obj.value
          }
          let isJson = false
          try {
            let rr = JSON.parse(obj.value)
            isJson = true
            // 解决JSON.parse('111') 得 111 非JSON bug，但引发itemType2 原本显示的text不显示而显示value（一个ID）
            // if(rr && (typeof rr == 'object')){
            //     isJson = true;
            // }else {
            //     isJson = false;
            // }
          } catch (e) {
            isJson = false
          }
          if (isJson) {
            obj.value = JSON.parse(obj.value)
          }
          return obj
        })
        return newItem
      })
      return newRequireItems
    },
    openImgTextDetail() {
      const skuid = this.selectedSku && this.selectedSku.skuId
      const popid = this.product && this.product.businessId
      this.newTrackClick(
        200006,
        undefined,
        `skuid: ${skuid || ''}, popid: ${popid || ''}`,
        121012367
      )
      this.isAllImgText = !this.isAllImgText
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.serve_introduce {
  h3 {
    padding-top: rem(32px);
    font-size: rem(26px);
    color: #262626;
    font-weight: bold;
    span {
      font-weight: normal;
      font-size: rem(24px);
      color: #808080;
    }
  }

  .serve_total_detail {
    padding: rem(24px) rem(30px);
    // font-weight: 700;
    font-size: 0.3rem;
    color: #121212;
    background-color: #fff;
  }

  .margin_img_text {
    margin-bottom: rem(32px);
  }

  .serve_introduce_title {
    font-size: rem(28px);
    color: #262626;
    line-height: rem(34px);
    background-position: left center;
    background-repeat: no-repeat;
    background-size: rem(26px);
    // padding-left: rem(42px);
  }
  .bright {
    padding-bottom: rem(32px);
    @include border(bottom);
  }
  .image_text {
    background-color: #fff;
    padding: 0 rem(30px);
    .image_text_title {
      background-image: url('~@/assets/images/product/icon-twxq@3x.png');
      padding-top: rem(32px);
      padding-bottom: rem(32px);
    }
    .pDetail {
      width: 100%;
      text-align: center;
      overflow: hidden;
      margin-bottom: rem(32px);
      max-height: rem(420px);
      .img-detail {
        overflow: hidden;
      }
      img {
        max-width: 100%;
        display: block;
      }
    }

    &.isChildBirthSpuId {
      margin-top: 0;
      .pDetail {
        max-height: none;
        padding-bottom: 0.2rem;
        margin-bottom: 0;
      }
    }
  }
  .noMore {
    padding-bottom: rem(1px);
    .pDetail {
      max-height: none;
    }
    .more-look {
      display: none;
    }
  }
  .isAll {
    .pDetail {
      max-height: none;
    }
    .more-look {
      background-image: url('~@/assets/images/product/btn-sq@3x.png');
      background-size: rem(82px) auto;
    }
  }
}

.bright-content {
  padding: rem(30px) rem(30px) 0;
  background-color: #fff;
}
.bright_title {
  margin-bottom: rem(24px);
  background-image: url('~@/assets/images/product/icon-tcld@3x.png');
}
.content_title {
  // margin-bottom: rem(22px);
  background-image: url('~@/assets/images/product/icon-tcnr@3x.png');
}
.bright_title .content_detail {
  word-break: break-all;
  margin-top: rem(80px);
}

.bright .content_detail {
  margin-top: rem(10px);
  line-height: 1.4;
}

.content_detail {
  font-size: rem(26px);
  color: #262626;

  word-break: break-all;
  ul {
    li {
      position: relative;
      margin-top: rem(20px);
      line-height: rem(32px);
      display: flex;
      justify-content: space-between;
      padding-left: rem(20px);
      span {
        padding-left: rem(10px);
        flex: none;
      }
      &:before {
        content: '';
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 0;
        border-radius: 100%;
        background-color: #999;
        width: rem(8px);
        height: rem(8px);
        transform: translateY(-50%);
      }
    }
  }

  // 移到上层
  //   h3 {
  //     //padding-top: rem(26px);
  //     padding-bottom: rem(14px);
  //     line-height: rem(32px);
  //     font-size: rem(26px);
  //     color: #262626;
  //     font-weight: bold;
  //     span {
  //       font-weight: normal;
  //       font-size: rem(24px);
  //       color: #808080;
  //     }
  //   }
  p {
    line-height: rem(32px);
    font-size: rem(24px);
    color: #808080;
    padding-top: rem(24px);
    word-break: break-all;
  }
}
.combo-detail {
  padding: 0 rem(30px);
  margin-top: rem(10px);
  background-color: #fff;
  padding-top: rem(32px);
  &.isAll {
    padding-bottom: rem(10px);
  }
  .combo_title {
    background-image: url('~@/assets/images/product/icon-tcxq@3x.png');
  }
  > ul {
    margin-bottom: rem(32px);
    li {
      margin-top: rem(32px);
      border: 1px solid #f0f0f0;
      border-radius: rem(16px);
      overflow: hidden;
      h4 {
        height: rem(72px);
        line-height: rem(72px);
        background-color: #fff2eb;
        padding: 0 rem(24px);
        font-size: rem(28px);
        font-weight: 700;
        color: #262626;
      }
    }
  }
}
.block-ui {
  padding: rem(16px) rem(25px);

  .one-line {
    display: flex;
    align-items: flex-start;
    font-size: rem(26px);
    margin: rem(10px) 0;
    &:last-child {
      margin-bottom: 0;
    }
    label {
      flex: none;
      width: rem(152px);
      color: #333;
    }
    div {
      color: #000;
      flex: auto;
      p {
        line-height: rem(32px);
        padding-bottom: rem(12px);
        &:last-child {
          padding-bottom: 0;
        }
      }
      &.one-line-ul.position-ui {
        display: flex;
        flex-wrap: wrap;
        > p {
          > span {
            display: none;
          }
          &:last-child {
            i {
              display: none;
            }
          }
        }
      }
    }
  }
}
.more-look {
  display: block;
  width: 100%;
  height: rem(96px);
  background: url('~@/assets/images/product/btn-ckgd@3x.png') no-repeat;
  background-position: center;
  background-size: rem(134px) auto;
  margin-top: rem(-32px);
}
</style>
